import { createClient } from "@supabase/supabase-js";
import supabaseConfig from "./supabaseConfig";

const supabaseUrl = supabaseConfig.supabaseUrl;
const supabaseAnonKey = supabaseConfig.supabaseAnonKey;

// In tests, fall back to dummy values to allow rendering without env vars.
const isTest = process.env.NODE_ENV === "test";
const resolvedUrl =
  supabaseUrl || (isTest ? "https://placeholder.supabase.co" : "");
const resolvedAnonKey =
  supabaseAnonKey || (isTest ? "test-anon-key" : "");

if (!resolvedUrl || !resolvedAnonKey) {
  throw new Error("Missing Supabase environment variables");
}

export const supabase = createClient(resolvedUrl, resolvedAnonKey, {
  auth: {
    detectSessionInUrl: false,
  },
});

export default supabase;
